import {RestResource} from "../rest";
import {TICKET_SERVER} from "../server";
import {athubAxios} from "../../util/athub-axios";

const problem = new RestResource({server: TICKET_SERVER, resource: 'problem'});

/**
 * 问题完成率统计
 * @param params
 * @returns {Promise<unknown>}
 */
problem.queryProblemCompletionRate = (params) => {
    let url = `${TICKET_SERVER}/problem/completionRate`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, params).then(responseBody => {
            if (responseBody.data.code == 200) {
                resolve(responseBody.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

problem.page = (params) => {
    let url = `${TICKET_SERVER}/problem/managements`;
    return athubAxios.postByMultipartForm(url, params);
}

export default problem;